//上拉请求状态位
let pullUpActionFlag = true;

const IScroll = window.iScroll;

let pullDownEl;
let pullDownOffset;
let pullUpEl;
let pullUpOffset;

let renderFunc;

let pullDownAction = function() {
  myScroll.refresh();
}

let pullUpAction = function() {
  pullUpActionFlag = false;

  pullUpEl.find('.pull-up-img').show();

  if (pullUpEl.css('display') === 'none') {
    pullUpActionFlag = true;

    return false;
  }else {
    setTimeout(renderData(renderFunc), 300);

    pullUpActionFlag = true;
  }
}

export function loaded(){
  pullDownEl = $('#J_PullDown');
  pullDownOffset = pullDownEl.offset().height;
  pullUpEl = $('#J_PullUp');
  pullUpOffset = pullUpEl.offset().height;

  myScroll = new IScroll('wrapper', {
    zoom: true,
    mouseWheel: true,
    wheelAction: 'zoom',
    useTransition: true,
    onRefresh: function() {
      if (pullDownEl.hasClass('loading')) {
        pullDownEl.attr('class', '');
        pullDownEl.find('.refresh-down-label').html('');
      } else if (pullUpEl.hasClass('loading')) {
        pullUpEl.attr('class', '');
        pullUpEl.find('.refresh-up-label').html('More');
        pullUpEl.find('.pull-up-img').hide();
      }
    },
    onScrollMove: function() {
      $('#J_CommonFooter').hide();

      if (this.y > 5 && !pullDownEl.hasClass('flip')) {
        pullDownEl.attr('class', 'flip');
        pullDownEl.find('.refresh-down-label').html('');
        this.minScrollY = 0;
      } else if (this.y < 5 && pullDownEl.hasClass('flip')) {
        pullDownEl.attr('class', '');
        pullDownEl.find('.refresh-down-label').html('');
        this.minScrollY = -pullDownOffset;
      } else if (this.y < (this.maxScrollY - 5) && !pullUpEl.hasClass('flip')) {
        pullUpEl.attr('class', 'flip');
        pullUpEl.find('.refresh-up-label').html('Loading...');
        this.maxScrollY = this.maxScrollY;
      } else if (this.y > (this.maxScrollY + 5) && pullUpEl.hasClass('flip')) {
        pullUpEl.attr('class', '');
        pullUpEl.find('.refresh-up-label').html('More');

        this.maxScrollY = pullUpOffset;
      }
    },
    onScrollEnd: function() {
      $('#J_CommonFooter').show();

      if (pullDownEl.hasClass('flip')) {
        pullDownEl.attr('class', 'loading');
        pullDownEl.find('.refresh-down-label').html('');
        pullDownAction();
      } else if (pullUpEl.hasClass('flip')) {
        pullUpEl.attr('class', 'loading');

        pullUpEl.find('.refresh-up-label').html('');

        if(pullUpActionFlag){
          pullUpAction();
        }
      }
    }
  });

  setTimeout(function() { document.getElementById('wrapper').style.left = '0';}, 800);

  $(window).resize(function () {
    myScroll.refresh();
  });
}

export function renderData(callback){
  callback();

  renderFunc = callback;
}



// WEBPACK FOOTER //
// ./src/utils/refresh.js